var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"angle t_l"}),_c('div',{staticClass:"angle t_r"}),_c('div',{staticClass:"angle b_l"}),_c('div',{staticClass:"angle b_r"})])
}]

export { render, staticRenderFns }